import '@angular/common/locales/global/it';
import '@angular/common/locales/global/en';

// Modules
import { Injector, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CdkModule } from '@app/cdk.module';
import { DevExpressModule } from '@app/devexpress.module';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from '@app/app-routing.module';
import { CoreModule } from '@common/core.module';

// Components
import { AppComponent } from '@app/app.component';

import { CoreRegisterAccountComponent } from './core/components/core-register-account/core-register-account.component';
import { setRootInjector } from './core/injector/root-injector';

@NgModule({
  declarations: [
    AppComponent,
    CoreRegisterAccountComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    CdkModule,
    DevExpressModule,
    HttpClientModule,
    CoreModule,
    AppRoutingModule
  ],
  bootstrap: [AppComponent]
})

export class AppModule {
  constructor(injector: Injector) {
    setRootInjector(injector);
  }
}
